import { Outlet } from 'react-router';

import { TeamCommands } from '@components/features/CommandMenu/static/TeamCommands';
import Layout from '@components/features/Layout';
import * as Gateway from '@routes/Gateways';
import { TrackLocalTeamState } from '@routes/RedirectToFirstTeam';

import { LaunchDarklySubscriber } from './LaunchDarklyProvider';

export function AppLayout() {
  return (
    <Layout>
      <Layout.Navigation />
      <Layout.Body>
        <Outlet />
      </Layout.Body>
      <Layout.Footer />
    </Layout>
  );
}

export function TeamLayout() {
  return (
    <Gateway.RequireTeamAccess>
      <TeamCommands />
      <LaunchDarklySubscriber />
      <TrackLocalTeamState />
      <Outlet />
    </Gateway.RequireTeamAccess>
  );
}
